import { talksGalleryCustomAttributes } from '../getTalksGalleryFilterSections/getTalksGalleryFilterSections';
import type { TalksGalleryParams } from '#lib/websites/talks/api/getTalksGalleryPage.js';
import { TalksGallerySort } from '#lib/websites/talks/constants/sorting.js';
import type { FilterSections } from '$global/features/filter-drawer/types';
import { getAppliedFilters } from '$global/features/filter-drawer/utils/getAppliedFilters/getAppliedFilters';
import { getAppliedSort } from '$global/features/filter-drawer/utils/getAppliedSort/getAppliedSort';

// The GraphQL-shaped attribute objects the shared filter drawer produces —
// one entry per applied section, in the exact shapes getFilterAttributes
// builds for this page's field_names and custom attribute.
interface AppliedTalksFilter {
	speakers?: { HENI_Talks_Speakers_id: { name: { _in: string[] } } };
	series?: { HENI_Talks_Series_id: { title: { _in: string[] } } };
	tags?: { HENI_Talks_Tags_id: { name: { _in: string[] } } };
	time_period?: { name: { _in: string[] } };
	displaying_until?: { _neq: null };
}

// Translates the drawer's applied filters and sort into the REST endpoint's
// query params. The drawer machinery stays untouched and generic; only this
// last step knows the page moved off GraphQL.
export const getTalksGalleryRestParams = ({
	searchParams,
	filterSections,
	now,
}: {
	searchParams: URLSearchParams;
	filterSections: FilterSections;
	now: string;
}): TalksGalleryParams => {
	const applied = getAppliedFilters({
		searchParams,
		filterSections,
		customAttributes: talksGalleryCustomAttributes,
	}) as AppliedTalksFilter[];

	const sort = getAppliedSort({
		searchParams,
		defaultSort: [TalksGallerySort.Newest],
	});

	const params: TalksGalleryParams = {
		now,
		sort:
			sort[0] === TalksGallerySort.Oldest ? 'release_date' : '-release_date',
	};

	applied.forEach((entry) => {
		if (entry.speakers) {
			params.speakers = entry.speakers.HENI_Talks_Speakers_id.name._in;
		}
		if (entry.series) {
			params.series = entry.series.HENI_Talks_Series_id.title._in;
		}
		if (entry.tags) {
			params.themes = entry.tags.HENI_Talks_Tags_id.name._in;
		}
		if (entry.time_period) {
			params.timePeriods = entry.time_period.name._in;
		}
		if (entry.displaying_until) {
			params.limitedTime = 'true';
		}
	});

	return params;
};
